import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";

/** Create or edit a single registry update. */
export default function UpdateDialog({ open, onOpenChange, existing, onSaved }) {
  const [form, setForm] = useState({ title: "", body: "" });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (existing) setForm({ title: existing.title, body: existing.body });
    else setForm({ title: "", body: "" });
  }, [existing, open]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = existing
        ? await api.put(`/registry/me/updates/${existing.id}`, form)
        : await api.post("/registry/me/updates", form);
      toast.success(existing ? "Updated." : "Posted.");
      onSaved(data);
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Couldn't save.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="update-dialog">
        <DialogHeader>
          <DialogTitle className="font-outfit">{existing ? "Edit update" : "Post an update"}</DialogTitle>
          <DialogDescription>
            Share how recovery is going, say thanks, or ask for something specific.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block">Title</label>
            <input
              required
              maxLength={200}
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              className="input-soft"
              placeholder="Day 3: lots of tea, zero regrets"
              data-testid="update-title-input"
            />
          </div>
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block">Update</label>
            <textarea
              required
              rows={8}
              maxLength={5000}
              value={form.body}
              onChange={(e) => setForm({ ...form, body: e.target.value })}
              className="input-soft"
              placeholder="Surgery went smoothly. The heating pad was a lifesaver…"
              data-testid="update-body-input"
            />
          </div>
          <DialogFooter>
            <button type="button" onClick={() => onOpenChange(false)} className="btn-ghost">Cancel</button>
            <button type="submit" disabled={submitting} className="btn-primary" data-testid="update-submit">
              {submitting ? "Saving…" : existing ? "Save" : "Post update"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
